var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"submenu",class:{open: _vm.$root.currentSubMenu === _vm.name}},_vm._l((_vm.routes),function(route){return _c('li',{key:route},[_c('router-link',{attrs:{"to":{name: route, params: { lang: _vm.$route.params.lang }}}},[_vm._v(_vm._s(_vm.$t(("nav." + route))))])],1)}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-596f8283","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavSubmenu.vue
// module id = null
// module chunks = 